import { useEffect } from "react";
import { Container } from "@/components/Container";
import { useParams } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { usePersonaQuery } from "@/api/personas";
import CandleStickChart from "@/components/Chart";
import { PersonaHeaderSection } from "@/components/PersonaHeaderSection";

const ViewTokenPage = () => {
  const { personaId } = useParams();
  const { toast } = useToast();
  const { data: persona = undefined, isError } = usePersonaQuery(
    true,
    personaId ?? "",
  );

  const personaData = persona ?? {
    persona_id: "",
    avatar_id: "",
    name: "",
    web3: { contractAddress: "", cluster: "mainnet" },
    gender: "male",
  };

  const getEndpointForCluster = (cluster: string | undefined) => {
    const MAINNET_BETA_DOMAINS = ["https://api.mainnet-beta.solana.com"];
    const DEVNET_DOMAINS = ["https://api.devnet.solana.com"];
    const TESTNET_DOMAINS = ["https://api.testnet.solana.com"];

    switch (cluster) {
      case "mainnet":
        return MAINNET_BETA_DOMAINS[
          Math.floor(Math.random() * MAINNET_BETA_DOMAINS.length)
        ];
      case "testnet":
        return TESTNET_DOMAINS[0]; // Only one domain for testnet
      case "devnet":
      default:
        return DEVNET_DOMAINS[
          Math.floor(Math.random() * DEVNET_DOMAINS.length)
        ];
    }
  };

  const endpoint = getEndpointForCluster(personaData.web3?.cluster);

  useEffect(() => {
    if (isError) {
      toast({ description: "Error loading agent or documents" });
    }
  }, [isError]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://terminal.jup.ag/main-v3.js";
    script.onload = () => {
      // @ts-expect-error injected in runtime
      if (window.Jupiter) {
        // @ts-expect-error injected in runtime
        window.Jupiter.init({
          displayMode: "integrated",
          integratedTargetId: "integrated-terminal",
          endpoint: endpoint,
          formProps: {
            fixedOutputMint: true,
            swapMode: "ExactIn",
            initialOutputMint: personaData.web3?.contractAddress || "",
            initialInputMint: "So11111111111111111111111111111111111111112",
          },
        });
      }
    };
    document.body.appendChild(script);

    // Cleanup script when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, [endpoint, personaData.web3?.contractAddress]);

  if (!personaId) {
    return <div>Error: Agent ID is required.</div>;
  }

  return (
    <Container>
      <PersonaHeaderSection className="py-4" personaData={personaData} />

      {/* Candlestick Chart and Swap Widget */}
      <div className="flex justify-between mt-10">
        {/* Chart - 75% of width */}
        <div className="w-2/3">
          <CandleStickChart
            blockchain={personaData.web3?.cluster}
            contractAddress={personaData.web3?.contractAddress}
          />
        </div>

        {/* Swap Widget - 25% of width */}
        <div className="w-1/3">
          <div
            id="integrated-terminal"
            style={{
              width: "100%",
              height: "350px",
              border: "0px",
              borderRadius: "8px",
            }}
          ></div>
        </div>
      </div>
    </Container>
  );
};

export default ViewTokenPage;
